import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { TreeChild2 } from "../../redux/reducers/AssetReducer";

export const useGetWell = (id: String) => {
  let finish = false;
  let well: TreeChild2 = {
    id: "",
    name: "",
    metadata: { "well-type": "" },
  };

  const treeData = useSelector((state: RootState) => state.asset.tree);
  const realTreeData = treeData.children!;

  for (let i = 0; i < realTreeData.length; i++) {
    if (finish) {
      break;
    }
    if (realTreeData[i].hasOwnProperty("children")) {
      for (let j = 0; j < realTreeData[i].children!.length; j++) {
        if (finish) {
          break;
        }
        if (realTreeData[i].children![j].hasOwnProperty("children")) {
          for (let k = 0; k < realTreeData[i].children![j].children!.length; k++) {
            if (finish) {
              break;
            }
            if (realTreeData[i].children![j].children![k].hasOwnProperty("children")) {
              for (let l = 0; l < realTreeData[i].children![j].children![k].children!.length; l++) {
                if (realTreeData[i].children![j].children![k].children![l].id === id) {
                  well = realTreeData[i].children![j].children![k].children![l];
                  finish = true;
                  break;
                }
              }
            }
          }
        }
      }
    }
  }

  return well;
};
